import { render } from "./FolderDialog.vue?vue&type=template&id=1de27486&scoped=true"
import script from "./FolderDialog.vue?vue&type=script&lang=js"
export * from "./FolderDialog.vue?vue&type=script&lang=js"

import "./FolderDialog.vue?vue&type=style&index=0&id=1de27486&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de27486"],['__file',"src/components/FolderDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de27486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de27486', __exports__)) {
    api.reload('1de27486', __exports__)
  }
  
  module.hot.accept("./FolderDialog.vue?vue&type=template&id=1de27486&scoped=true", () => {
    api.rerender('1de27486', render)
  })

}


export default __exports__